<template>
  <q-page padding>
    <PageHeader>
      <template #title>
        Capacitação : {{ detalhesCapacitacao.descricao }}
      </template>
    </PageHeader>

    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Status</div>
        <q-input
          v-model="detalhesCapacitacao.status"
          disable
          bg-color="brand-7"
          dense
          outlined
          class="input"
        />
      </div>
      <div
        v-if="!editarData"
        class="col-lg-2 col-md-2 col-sm-6 col-xs-6 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm texto-titulo-input">Data Aplicação</div>
        <q-input
          dense
          disable
          bg-color="brand-7"
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          v-model="dados.dataAplicacao"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="dados.dataAplicacao"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div
        v-else
        class="col-lg-2 col-md-2 col-sm-6 col-xs-6 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm texto-titulo-input">Data Aplicação</div>
        <q-input
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          v-model="dados.novaData"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="dados.novaData"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div>
        <p></p>
        <q-btn
          v-if="!editarData"
          :disable="!permissao"
          class="q-mt-sm btn"
          label="Editar Data"
          icon="edit"
          color="primary"
          no-caps
          dense
          @click="(editarData = true), receberDadosData()"
        />
        <q-btn
          v-else
          :disable="!permissao"
          class="q-mt-sm btn"
          label="Salvar"
          icon="check_circle_outline"
          color="positive"
          no-caps
          dense
          @click="modificarData()"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm"
          dense
          label="Coletar Assinatura Instrutor"
          no-caps
          color="black"
          outline
          icon="history_edu"
          @click="coletarAssinatura = true"
        />
        <q-btn
          class="q-ml-sm q-mt-sm btn"
          label="Imprimir"
          icon="print"
          color="secondary"
          no-caps
          dense
          @click="imprimir"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Treinamentos Definidos
        </span>
      </div>
      <q-table
        :columns="columns"
        :rows="detalhesCapacitacao.treinamentos"
        :loading="loading"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        dense
        hide-bottom
        class="tabela-tamanho-fixo"
        :grid="$q.screen.lt.sm"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Nome: </strong>
                    {{ props.row.nome }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Reciclagem: </strong>
                    {{ props.row.reciclagem == 1 ? "Sim" : "Não" }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Validade: </strong>
                    {{
                      props.row.validade == 1
                        ? `${props.row.validade} Dia`
                        : `${props.row.validade} Dias`
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Instrutor: </strong>
                    {{ props.row.instrutor }}</span
                  >

                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Imprimir Treinamento: </strong>
                    <q-btn
                      class="q-ml-sm q-mt-sm btn"
                      round
                      icon="print"
                      color="secondary"
                      no-caps
                      @click="imprimir(props.row.treinamentoId)"
                  /></span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-reciclagem="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.reciclagem == 1 ? "Sim" : "Não" }}
          </q-td>
        </template>
        <template v-slot:body-cell-validade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.validade == 1
                ? `${props.row.validade} Dia`
                : `${props.row.validade} Dias`
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-instrutor="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.instrutor }}
          </q-td>
        </template>
        <template v-slot:body-cell-imprimir="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-btn
              class="q-ml-sm q-mt-sm btn"
              round
              icon="print"
              color="secondary"
              no-caps
              @click="imprimir(props.row.treinamentoId)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Participantes
        </span>
      </div>
      <div
        class="input-search-table justify-end row col-md-3 col-xs-12 col-sm-12 q-mb-md"
      >
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filter"
          type="text"
          placeholder="Filtrar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
      <div>
        <q-table
          :grid="$q.screen.lt.sm"
          :columns="columns2"
          :rows="detalhesCapacitacao.funcionarios"
          color="primary"
          class="my-sticky-dynamic"
          flat
          dense
          hide-pagination
          :loading="loading"
          hide-bottom
          row-key="nome"
          :rows-per-page-options="[0]"
          :filter="filter"
        >
          <template v-slot:item="props">
            <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
              <div class="row card text-grid-table text-brand-5 q-pa-sm">
                <div
                  class="row col-12 justify-center items-center justify-between"
                >
                  <div class="col-8">
                    <span class="row col-12 q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Nome: </strong>
                      {{ props.row.nome }}</span
                    >
                    <span class="row col-12 items-center q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Presença: </strong>
                      {{ props.row.presenca == 1 ? "Presente" : "" }}
                      {{ props.row.presenca == 0 ? "Ausente" : "" }}
                      {{ props.row.presenca == null ? "Não Confirmada" : ""
                      }}<q-icon
                        v-if="props.row.presenca == null"
                        color="red"
                        size="16px"
                        style="cursor: pointer; margin-left: 3px"
                        name="cancel"
                        @click="confirmarPresenca(props.row.funcionarioId)"
                    /></span>
                  </div>
                  <div class="col-3">
                    <div v-if="props.row.authType == 'lista'">
                      <a :href="props.row.authContent">
                        <q-icon
                          style="cursor: pointer"
                          color="brand-1"
                          size="30px"
                          name="description"
                        />
                      </a>
                    </div>
                    <div v-else>
                      <q-img
                        width="70px"
                        id="image"
                        :src="props.row.authContent"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td class="text-brand-5 text-weight-bold">
                <span>{{ props.row.nome }}</span>
              </q-td>
              <q-td class="text-brand-5 text-weight-bold">{{
                props.row.usuarioId
              }}</q-td>
              <q-td class="text-brand-5 text-weight-bold"> </q-td>
              <q-td class="text-brand-5 text-weight-bold">
                {{ props.row.presenca == 1 ? "Presente" : "" }}
                {{ props.row.presenca == 0 ? "Ausente" : "" }}
                {{ props.row.presenca == null ? "Não Confirmada" : ""
                }}<q-icon
                  v-if="props.row.presenca == null"
                  color="red"
                  size="16px"
                  style="cursor: pointer; margin-left: 3px"
                  name="cancel"
                  @click="confirmarPresenca(props.row.funcionarioId)"
                />
              </q-td>
              <q-td class="text-brand-5 text-weight-bold">
                <q-btn
                  :disable="props.row.presenca != 1"
                  icon="newspaper"
                  color="primary"
                  round
                  @click="imprimirCertificado(props.row.funcionarioId)"
                />
              </q-td>
              <q-td class="text-brand-5 text-weight-bold">
                <div v-if="props.row.authType == 'assinatura'">
                  <q-img
                    height="80px"
                    width="140px"
                    id="image"
                    fit="fill"
                    :src="props.row.authContent"
                  />
                </div>
                <div v-if="props.row.authType == 'biometria'">
                  <q-img fit="fill" id="image" :src="props.row.authContent" />
                </div>
                <div v-if="props.row.authType == 'lista'">
                  <a :href="props.row.authContent">
                    <q-icon
                      style="cursor: pointer"
                      color="brand-1"
                      size="30px"
                      name="description"
                    />
                  </a>
                </div>
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>
    <q-dialog v-model="coletarAssinatura">
      <q-card class="card-canvas" style="width: 760px; max-width: 80vw">
        <q-card-section class="q-mx-sm">
          <div class="text-brand-5 text-weight-bold text-h6 q-mb-md">
            Coletar Assinatura Instrutor
          </div>
          <Canvas
            @update="receberAssinatura"
            @assinar="enviarAssinaturaInstrutor"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";

import Canvas from "../components/Canvas.vue";
import PageHeader from "../../../../components/PageHeader.vue";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "reciclagem",
    label: "Reciclagem",
    align: "left",
  },
  {
    name: "validade",
    label: "Validade",
    align: "left",
  },
  {
    name: "instrutor",
    label: "Instrutor",
    align: "left",
  },
  {
    name: "imprimir",
    label: "Imprimir Lista de Presença",
    align: "center",
  },
];

const columns2 = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
    field: "nome",
  },
  {
    name: "idMatricula",
    label: "ID (Matricula)",
    align: "left",
    field: "matricula",
  },
  {
    name: "email",
    label: "Email",
    align: "left",
  },
  {
    name: "presenca",
    label: "Presença",
    align: "left",
  },
  {
    name: "certificado",
    label: "Certificado",
    align: "left",
  },
  {
    name: "autenticacao",
    label: "Autenticação",
    align: "left",
  },
];
export default {
  components: { Canvas, PageHeader },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const quasar = useQuasar();

    const capacitacaoId = route.params.capacitacaoId;
    const detalhesCapacitacao = ref([]);
    const filter = ref("");
    const dados = ref({
      novaData: "",
      dataAplicacao: "",
    });
    let editarData = ref(false);
    let permissao = ref(false);
    let loading = ref(false);
    let coletarAssinatura = ref(false);
    const imagemBase64 = ref(null);

    const detalharCapacitacao = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      try {
        loading.value = true;
        const response = await store.dispatch(
          "treinamento/detalharCapacitacao",
          {
            capacitacao_id: capacitacaoId,
          }
        );
        detalhesCapacitacao.value = response.data;
        dados.value.dataAplicacao = detalhesCapacitacao.value.dataRealizacao
          ?.split("-")
          .reverse()
          .join("/");
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const verificarAutorizacaoEdicao = async () => {
      try {
        const response = await store.dispatch(
          "treinamento/verificarAutorizacaoEdicao"
        );
        permissao.value = response.data.permission;
      } catch (error) {
        console.log(error);
      }
    };

    const receberDadosData = () => {
      dados.value.novaData = dados.value.dataAplicacao;
    };

    const modificarData = async () => {
      if (dados.value.dataAplicacao == dados.value.novaData) {
        editarData.value = false;
        return;
      }
      try {
        await store.dispatch("treinamento/modificarData", {
          capacitacaoId: capacitacaoId,
          dataRealizacao: dados.value.novaData,
        });
        editarData.value = false;
        detalharCapacitacao();
        quasar.notify({
          message: "Data modificada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao modificar data",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const confirmarPresenca = async (id) => {
      try {
        await store.dispatch("treinamento/confirmarPresenca", {
          capacitacaoId: capacitacaoId,
          id: id,
          presenca: 0,
        });
        detalharCapacitacao();
        quasar.notify({
          message: "Presença alterada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao alterar presença",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const voltar = () => {
      router.push({ name: "treinamento-listar-capacitacoes" });
    };

    const imprimirCertificado = async (id) => {
      let cliente = store.state.autenticacao.cliente;
      if (cliente.includes("mosb")) {
        router.push({
          name: "treinamento-imprimir-certificado-alterado",
          params: { funcionarioId: id },
        });
        return;
      }
      router.push({
        name: "treinamento-imprimir-certificado",
        params: { funcionarioId: id },
      });
    };

    const receberAssinatura = (value) => {
      imagemBase64.value = value;
    };

    const imprimir = async (treinamentoId) => {
      console.log(treinamentoId);
      const resolve = {
        capacitacaoId: capacitacaoId,
        treinamentoId: treinamentoId,
      };
      const routeData = router.resolve({
        name: "treinamento-presenca-imprimir",
        params: {
          dados: JSON.stringify(resolve),
        },
      });
      window.open(routeData.href, "_blank");
    };

    const enviarAssinaturaInstrutor = async () => {
      try {
        await store.dispatch("treinamento/coletarAssinaturaInstrutor", {
          capacitacao_uuid: capacitacaoId,
          assinatura: imagemBase64.value.split("base64,")[1],
        });
        coletarAssinatura.value = false;
        detalharCapacitacao();
        quasar.notify({
          message: "Assinatura coletada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao coletar assinatura.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(detalharCapacitacao);
    onMounted(verificarAutorizacaoEdicao);

    return {
      columns,
      columns2,
      capacitacaoId,
      detalhesCapacitacao,
      detalharCapacitacao,
      dados,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      editarData,
      receberDadosData,
      verificarAutorizacaoEdicao,
      permissao,
      modificarData,
      voltar,
      loading,
      confirmarPresenca,
      imprimirCertificado,
      filter,
      imprimir,
      coletarAssinatura,
      imagemBase64,
      receberAssinatura,
      enviarAssinaturaInstrutor,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.cursor {
  cursor: pointer;
}
#image {
  width: 35px;
}
@media (max-width: 600px) {
  .my-sticky-dynamic {
    max-height: 1000px;
  }
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .cursor {
    font-size: 14px !important;
    margin-top: 18px !important;
  }
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }

  .input {
    font-size: 12px;
  }
  .btn {
    margin: 5px 0px 0px 0px;
    font-size: 12px;
  }

  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
